import { gql } from "apollo-angular";

export const fragmentCimNotification = gql`
  fragment cimNotification on NotificationType {
    category
    endDate
    heading
    id
    impact
    planDate
    startDate
    status
    summary
    tags
    type
    updates {
      language
      description
      timestamp
    }
    urgency
  }
`;

export const fragmentCimAffectedSubscriptions = gql`
  fragment cimAffectedSubscriptions on NotificationType {
    affectedSubscriptions @include(if: $includeAffectedSubscriptions) {
      subscriptionId
      impactType
      subscription {
        subscriptionId
        customerId
        description
        product {
          type
          tag
          name
        }
        customerDescription
      }
    }
  }
`;

export const CIM_QUERY = gql`
  ${fragmentCimNotification}
  ${fragmentCimAffectedSubscriptions}
  query CimNotifications($filter: NotificationFilter!, $includeAffectedSubscriptions: Boolean = true) {
    notifications(searchFilter: $filter) {
      ...cimNotification
      ...cimAffectedSubscriptions
    }
  }
`;

export const CIM_SUBSCRIPTION = gql`
  ${fragmentCimNotification}
  query CimNotificationsSubscription($filter: NotificationFilter!) {
    notifications(searchFilter: $filter) {
      ...cimNotification
    }
  }
`;

export const CIM_MAJOR_DISRUPTION_QUERY = gql`
  ${fragmentCimNotification}
  query CimMajorDisruptionNotifications($filter: MajorDisruptionNotificationFilter!) {
    majorDisruptionNotifications(searchFilter: $filter) {
      ...cimNotification
    }
  }
`;
